import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Overview = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Overview.vue');
const DailyStats = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/DailyStats.vue');
const StatusBreakdown = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/StatusBreakdown.vue');
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Search.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// User Profile (Logged in User)
const ProfileShow = () => import(/* webpackChunkName: "tables" */ '@/views/Profile/Show.vue');

// Users
const UsersIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Users/Index.vue');
const UsersShow = () => import(/* webpackChunkName: "tables" */ '@/views/Users/Show.vue');
const UsersCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Users/Create.vue');

// Leads
const LeadsIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Leads/Index.vue');
const LeadsShow = () => import(/* webpackChunkName: "tables" */ '@/views/Leads/Show.vue');
const LeadsCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Leads/Create.vue');

// Contact Enquiries
const ContactIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Contact/Index.vue');
const ContactShow = () => import(/* webpackChunkName: "tables" */ '@/views/Contact/Show.vue');

// Applications
const ApplicationsIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Applications/Index.vue');
const ApplicationsShow = () => import(/* webpackChunkName: "tables" */ '@/views/Applications/Show.vue');
const ApplicationsEdit = () => import(/* webpackChunkName: "tables" */ '@/views/Applications/Edit.vue');
const ApplicationsCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Applications/Create.vue');

// Pos Applications
const PosApplicationsIndex = () => import(/* webpackChunkName: "tables" */ '@/views/PosApplications/Index.vue');
const PosApplicationsShow = () => import(/* webpackChunkName: "tables" */ '@/views/PosApplications/Show.vue');
const PosApplicationsEdit = () => import(/* webpackChunkName: "tables" */ '@/views/PosApplications/Edit.vue');
const PosApplicationsCreate = () => import(/* webpackChunkName: "tables" */ '@/views/PosApplications/Create.vue');

// Blog
const BlogIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Blogs/Index.vue');
const BlogShow = () => import(/* webpackChunkName: "tables" */ '@/views/Blogs/Show.vue');
const BlogCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Blogs/Create.vue');

// Companies
const CompanyIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Companies/Index.vue');
const CompanyShow = () => import(/* webpackChunkName: "tables" */ '@/views/Companies/Show.vue');

// Directors
const DirectorIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Directors/Index.vue');
const DirectorShow = () => import(/* webpackChunkName: "tables" */ '@/views/Directors/Show.vue');

// Websites
const WebsiteIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Websites/Index.vue');
const WebsiteShow = () => import(/* webpackChunkName: "tables" */ '@/views/Websites/Show.vue');

// Platforms
const PlatformIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Platforms/Index.vue');
const PlatformShow = () => import(/* webpackChunkName: "tables" */ '@/views/Platforms/Show.vue');
const PlatformCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Platforms/Create.vue');

// Activities
const ActivityIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Activities/Index.vue');
const ActivityShow = () => import(/* webpackChunkName: "tables" */ '@/views/Activities/Show.vue');

// Partners
const PartnerIndex = () => import(/* webpackChunkName: "tables" */ '@/views/Partners/Index.vue');
const PartnerShow = () => import(/* webpackChunkName: "tables" */ '@/views/Partners/Show.vue');
const PartnerCreate = () => import(/* webpackChunkName: "tables" */ '@/views/Partners/Create.vue');

let dashboardMenu = {
    path: '/dashboard',
    component: DashboardLayout,
    name: 'Dashboard',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Overview',
            component: Overview
        },
        {
            meta: {
                auth: true
            },
            path: 'daily-stats',
            name: 'Daily Stats',
            component: DailyStats
        },
        {
            meta: {
                auth: true
            },
            path: 'status-breakdown',
            name: 'Status Breakdown',
            component: StatusBreakdown
        },
    ]
};

let userProfile = {
    path: '/profile',
    component: DashboardLayout,
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Profile',
            component: ProfileShow
        }
    ]
};

let componentsMenu = {
    path: '/components',
    component: DashboardLayout,
    redirect: '/components/buttons',
    name: 'Components',
    children: [
        {
            meta: {
                auth: true
            },
            path: 'buttons',
            name: 'Buttons',
            component: Buttons
        },
        {
            meta: {
                auth: true
            },
            path: 'cards',
            name: 'Cards',
            component: Cards
        },
        {
            meta: {
                auth: true
            },
            path: 'grid-system',
            name: 'Grid System',
            component: GridSystem
        },
        {
            meta: {
                auth: true
            },
            path: 'notifications',
            name: 'Notifications',
            component: Notifications
        },
        {
            meta: {
                auth: true
            },
            path: 'icons',
            name: 'Icons',
            component: Icons
        },
        {
            meta: {
                auth: true
            },
            path: 'typography',
            name: 'Typography',
            component: Typography
        }
    ]
};

let formsMenu = {
    path: '/forms',
    component: DashboardLayout,
    redirect: '/forms/elements',
    name: 'Forms',
    children: [
        {
            meta: {
                auth: true
            },
            path: 'elements',
            name: 'Form elements',
            component: FormElements
        },
        {
            meta: {
                auth: true
            },
            path: 'components',
            name: 'Form components',
            component: FormComponents
        },
        {
            meta: {
                auth: true
            },
            path: 'validation',
            name: 'Form validation',
            component: FormValidation
        }
    ]
};

let usersMenu = {
    path: '/users',
    component: DashboardLayout,
    name: 'Users',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: UsersIndex,
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: UsersCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: UsersShow
        },
        
    ]
};

let leadsMenu = {
    path: '/leads',
    component: DashboardLayout,
    name: 'Leads',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: LeadsIndex,
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: LeadsCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: LeadsShow
        },
    ]
};

let contactMenu = {
    path: '/contact',
    component: DashboardLayout,
    name: 'Contact Enquiries',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: ContactIndex,
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: ContactShow
        }
    ]
};

let applicationsMenu = {
    path: '/applications',
    component: DashboardLayout,
    name: 'Applications',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: ApplicationsIndex,
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: ApplicationsCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: ApplicationsShow
        },
        
        {
            meta: {
                auth: true
            },
            path: ':id/edit',
            name: 'Edit',
            component: ApplicationsEdit
        },
    ]
};

let posApplicationsMenu = {
    path: '/pos-applications',
    component: DashboardLayout,
    name: 'Pos Applications',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: PosApplicationsIndex,
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: PosApplicationsCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: PosApplicationsShow
        },
        {
            meta: {
                auth: true
            },
            path: ':id/edit',
            name: 'Edit',
            component: PosApplicationsEdit
        },
    ]
};

let blogsMenu = {
    path: '/blog',
    component: DashboardLayout,
    name: 'Blog',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: BlogIndex
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: BlogCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: BlogShow
        },
        
    ]
};

let companiesMenu = {
    path: '/companies',
    component: DashboardLayout,
    name: 'Companies',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: CompanyIndex
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: CompanyShow
        },
    ]
};

let directorsMenu = {
    path: '/directors',
    component: DashboardLayout,
    name: 'Directors',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: DirectorIndex
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: DirectorShow
        },
    ]
};

let websitesMenu = {
    path: '/websites',
    component: DashboardLayout,
    name: 'Websites',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: WebsiteIndex
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: WebsiteShow
        },
    ]
};

let platformsMenu = {
    path: '/platforms',
    component: DashboardLayout,
    name: 'Platforms',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: PlatformIndex
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: PlatformCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: PlatformShow
        },
    ]
};

let pagesMenu = {
    path: '/pages',
    component: DashboardLayout,
    name: 'Pages',
    redirect: '/pages/user',
    children: [
        {
            meta: {
                auth: true
            },
            path: 'user',
            name: 'User Page',
            component: User
        },
        {
            meta: {
                auth: true
            },
            path: 'timeline',
            name: 'Timeline Page',
            component: TimeLine
        }
    ]
};

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: {
                noBodyBackground: true
            }
        },
        {
            meta: {
                guest: true
            },
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            meta: {
                guest: true
            },
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/pricing',
            name: 'Pricing',
            component: Pricing
        },
        {
            meta: {
                guest: true
            },
            path: '/lock',
            name: 'Lock',
            component: Lock
        },
        {
            name: 'NotFound',
            path: '/404',
            component: NotFound
        },

        { path: '*', redirect: '/404' }
    ]
};

let activitiesMenu = {
    path: '/activities',
    component: DashboardLayout,
    name: 'Activities',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: ActivityIndex
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: ActivityShow
        },
    ]
};

let partnersMenu = {
    path: '/partners',
    component: DashboardLayout,
    name: 'Partners',
    children: [
        {
            meta: {
                auth: true
            },
            path: '/',
            name: 'Index',
            component: PartnerIndex
        },
        {
            meta: {
                auth: true
            },
            path: 'create',
            name: 'Create',
            component: PartnerCreate
        },
        {
            meta: {
                auth: true
            },
            path: ':id',
            name: 'Show',
            component: PartnerShow
        },
    ]
};



const routes = [
    dashboardMenu,
    userProfile,
    componentsMenu,
    formsMenu,
    leadsMenu,
    usersMenu,
    contactMenu,
    applicationsMenu,
    posApplicationsMenu,
    blogsMenu,
    companiesMenu,
    directorsMenu,
    websitesMenu,
    platformsMenu,
    blogsMenu,
    activitiesMenu,
    partnersMenu,
    pagesMenu,
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dashboard',
        name: 'Dashboard layout',
        children: [
            {
                meta: {
                    auth: true
                },
                path: 'search',
                name: 'Search',
                component: Search
            },
            {
                meta: {
                    auth: true
                },
                path: 'calendar',
                name: 'Calendar',
                component: Calendar
            },
            {
                meta: {
                    auth: true
                },
                path: 'charts',
                name: 'Charts',
                component: Charts
            },
            {
                meta: {
                    auth: true
                },
                path: 'widgets',
                name: 'Widgets',
                component: Widgets
            }
        ]
    },
    authPages,
];

export default routes;
